// ----------------------------------------------------------------------
import { useContext } from 'react';
import { OptionsContext } from '../contexts/OptionsContext';

export default function useOptions() {
  const { options, setOptions } = useContext(OptionsContext);

  return [options, setOptions];
}
